import axios from '../../http_v2'
export default {
    list: (params) => {
        return axios.post('activityservice/quota/page', params)
    },
    update: (params) => {
        return axios.post('activityservice/quota/upsert', params)
    },
    delAll: (params) => {
        return axios.post('activityservice/quota/batch', params)
    }
}
